import React, { Component } from 'react';

class ToggleSwitch extends Component {
  render () {
    const { input } = this.props;
    
    return <span className="toggle-switch">
      <input {...input} className="toggle-switch" type="checkbox" />
      <span className="toggle-switch-slider round"></span>
    </span>
  }
}


export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/components/form/ToggleSwitch.js